export enum HotelPromotionType {
  STAY_XPAY_Y = 'StayXPayY',
  PERCENT_DISCOUNT = 'PercentDiscount',
  VALUE_DISCOUNT = 'ValueDiscount',
  SETUR_POINT_EARN = 'SeturPointEarn',
  SETUR_POINT_USE = 'SeturPointUse',
}
